import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get projects by organization
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetProjectsByOrganization = packet => {
  return {
    type: 'REQUEST_GET_PROJECTS_BY_ORGANIZATION',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetProjectsByOrganizationSuccess = data => ({
  type: 'RECEIVE_GET_PROJECTS_BY_ORGANIZATION_SUCCESS',
  data
})

export const receiveGetProjectsByOrganizationFail = data => ({
  type: 'RECEIVE_GET_PROJECTS_BY_ORGANIZATION_FAIL',
  data
})

export const tryToGetProjectsByOrganization = packet => (dispatch, getState) => {

  dispatch(requestGetProjectsByOrganization(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }

  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  let url = '/api/projects/org/' + packet.org_id;
  if(packet.startAfter){
    url += '?startAfter=' + packet.startAfter;
  }

  return fetch(url, {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetProjectsByOrganizationSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetProjectsByOrganizationFail({errors:e, lastSubmit: packet}));
    })
}
